import firebase from "firebase";
import "firebase/auth";
import "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBgzX6Zbz1xcC0bSrg7Sl8GOXWu0LpqmTY",
  authDomain: "firechirp-6b4e1.firebaseapp.com",
  projectId: "firechirp-6b4e1",
  storageBucket: "firechirp-6b4e1.appspot.com",
  messagingSenderId: "190737050463",
  appId: "1:190737050463:web:24ef76f3bed35e144da4ea",
};

export const authUiConfig = {
  signInFlow: "popup",
  signInOptions: [
    firebase.auth.GoogleAuthProvider.PROVIDER_ID,
    firebase.auth.EmailAuthProvider.PROVIDER_ID,
  ],
  callbacks: {
    signInSuccessWithAuthResult: () => false,
  },
}

firebase.initializeApp(firebaseConfig);

export const postsRef = firebase.firestore().collection("posts");

export default firebase;
